import { SVGProps, ReactNode } from 'react';
import { dynamicStyling } from 'styles';

export interface CustomSVGProps {
  size?: number;
}

export interface Props extends CustomSVGProps, SVGProps<SVGSVGElement> {
  children: ReactNode;
}

export function SVG({ size, children, ...props }: Props) {
  return (
    <svg {...props} {...dynamicStyling({ size })}>
      {children}
    </svg>
  );
}
